import React, { type ComponentProps } from 'react';

import { theme } from '@garnish/constants';

import { ScreenHeaderButton } from '../ScreenHeaderButton';

// ─────────────────────────────────────────────────────────────────────────────

export const ScreenHeaderPointsButton = (props: Props) => {
  const { accessibilityLabel, points, text, ...restProps } = props;

  const buttonAccessibilityLabel = accessibilityLabel ?? [points, text].filter(Boolean).join(' ');

  return (
    <ScreenHeaderButton.Container
      accessibilityLabel={buttonAccessibilityLabel}
      palette="translucent"
      {...restProps}
    >
      <ScreenHeaderButton.Icon name="IconSgRewardKaleFill" />

      {points ? (
        <ScreenHeaderButton.Title color={theme.colors.WHITE}>{points}</ScreenHeaderButton.Title>
      ) : null}

      {text ? (
        <ScreenHeaderButton.Title color={theme.colors.WHITE} bold={!points}>
          {text}
        </ScreenHeaderButton.Title>
      ) : null}
    </ScreenHeaderButton.Container>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  points?: string;
  text?: string;
} & Omit<ComponentProps<typeof ScreenHeaderButton.Container>, 'children' | 'palette'>;
